/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { BigModal } from './BigModal';
import { Typography, Grid, Tabs, Tab, Box } from '@mui/material';
import { CustomTextField, InspectEmpDetails, ContainedButton } from '../index';
import { useEffect, useState } from 'react';

export const ViewEditRequestModal = (props) => {
  const [lastname, setLastname] = useState('');
  const [firstname, setFirstname] = useState('');
  const [middlename, setMiddleName] = useState('');
  const [email, setEmail] = useState('');
  const [tabValue, setTabValue] = useState('personalInfo');

  useEffect(() => {
    // Check if editRequest exists and has proposeddata
    if (!props.editRequest || Object.keys(props.editRequest).length === 0)
      return;

    const basicInfo = props.editRequest.proposeddata?.basicinfo || {};

    setLastname(basicInfo.lastname);
    setFirstname(basicInfo.firstname);
    setMiddleName(basicInfo.middlename);
    setEmail(basicInfo.email);
  }, [props.editRequest]);

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const handleClose = () => {
    props.onClose();
    setTabValue('personalInfo');
    props.onSuccess();
  };

  return (
    <>
      <BigModal
        style={{ display: 'flex', flexDirection: 'column' }}
        width={
          !props.editRequest || Object.keys(props.editRequest).length === 0
            ? '40%'
            : '80%'
        }
        open={props.open}
        onClose={handleClose}
      >
        {!props.editRequest || Object.keys(props.editRequest).length === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
              Try again later
            </Typography>
            <Typography sx={{ mx: 'auto', my: 'auto' }}>
              There is no pending edit request. It may have already been
              approved or rejected. Reload the page please.
            </Typography>
          </Box>
        ) : (
          <>
            <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
              Pending Edit Request:
            </Typography>

            <Grid container columnSpacing={4}>
              <Grid item xs={6}>
                <CustomTextField label="First Name" value={firstname} />
              </Grid>
              <Grid item xs={6}>
                <CustomTextField label="Last Name" value={lastname} />
              </Grid>
              <Grid item xs={6}>
                <CustomTextField label="Middle Name" value={middlename} />
              </Grid>

              <Grid item xs={6}>
                <CustomTextField label="Email" value={email} />
              </Grid>
            </Grid>

            <Box
              sx={{
                width: '100%',
                overflowY: 'auto',
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab value="personalInfo" label="Personal Information" />
                <Tab value="addresses" label="Addresses" />
                <Tab
                  value="familyBackground"
                  label="Family Background & Relations"
                />
                <Tab value="educBackground" label="Educational Background" />
                <Tab value="civService" label="Civil Service Eligibility" />
                <Tab value="workExp" label="Work Experience" />
                <Tab value="volWork" label="Voluntary Work" />
                <Tab value="trainingProgs" label="Training Programs" />
                <Tab value="history" label="History" />
              </Tabs>

              <Box sx={{}}>
                <InspectEmpDetails
                  viewOnly={true}
                  editRequest={props.editRequest}
                  currentTab={tabValue}
                />
              </Box>
            </Box>
          </>
        )}

        <Box display="flex">
          <ContainedButton
            onClick={handleClose}
            variant="contained"
            btnTitle="Close"
            style={{ width: 'auto', mt: 2, ml: 'auto' }}
          />
        </Box>
      </BigModal>
    </>
  );
};
